module.exports = __webpack_public_path__ + "img/girl_open_door.bd99ccab.png";